import { connect } from 'react-redux';
import { flow, get, getOr, find } from 'lodash/fp';
import ItemCard from './ItemCard';
import getItem from '../../../../../selectors/getItem';
import cookiesFactory from '../../../../../../../base/cookies-factory';
import isCustomerViewingCustomProduct from '../../../../../helpers/isCustomerViewingCustomProduct';
import { checkErrorMessage, containsSpecificError } from '../../../../../helpers/errorMessages';

const mapStateToProps = ({ estimateBuilder }, { itemId, isValidCopyStyles }) => {
  const { entities: { estimates } } = estimateBuilder;
  const item = getItem(estimateBuilder, itemId);
  const hasProduct = !!item.itemProduct;
  const { isValid: isCopyStylesValid, errors } = isValidCopyStyles;
  const isCopyStylesErrorMsg = containsSpecificError(errors, checkErrorMessage);
  const invalid = hasProduct ? !item.itemProduct.isValid : false;
  const isDiscontinued = (hasProduct && item.itemProduct.productStatus) ? item.itemProduct.productStatus === 'Discontinued' : false;
  const {
    isLockedOrOrdered,
    attributes: {
      isMandi,
      isAutoReleaseDesign,
    },
  } = estimates.byId[item.designId];

  const isInternalUser = cookiesFactory.isInternalUser();

  const isFlagged = !!flow(
    find({ name: 'flagNotes' }),
    // do NOT replace with size. If there are no flag notes, length won't get set and size
    // will return the number of properties on the flagNotes object which is non zero
    getOr(0, 'length'),
  )(item.attributes);
  const hasNotes = !!flow(
    find({ name: 'notes' }),
    // do NOT replace with size. If there are no notes, length won't get set and size
    // will return the number of properties on the notes object which is non zero
    getOr(0, 'length'),
  )(item.attributes);

  let flaggedWindowText = '';
  if (isFlagged) {
    flaggedWindowText = hasProduct
      ? 'Please contact a design consultant to make changes to this product.'
      : 'This window requires professional assistance prior to purchase.';
  }
  let itemCardBannerClass = '';
  if (isMandi && isInternalUser) {
    if (isFlagged) {
      itemCardBannerClass = 'flaggedWindowBanner';
    } else if (hasNotes || (!isCopyStylesValid && isCopyStylesErrorMsg)) {
      itemCardBannerClass = 'notedWindowBanner';
    }
  }
  const purchaseOption = find({ name: 'purchaseOption' })(item.attributes);

  const designId = get('designId')(item);

  return {
    itemId,
    hasProduct,
    isLockedOrOrdered,
    invalid,
    isMandi,
    isCopyStylesValid,
    isCopyStylesErrorMsg,
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
    isDiscontinued,
    isCustomerViewingCustomProduct: isCustomerViewingCustomProduct(item),
    isInternalUser,
    isFlagged,
    hasNotes,
    flaggedWindowText,
    itemCardBannerClass,
    purchaseOption,
    designId,
  };
};

export default connect(mapStateToProps)(ItemCard);
